<button
  [class]="'loading_button ' + buttonClass"
  [ngClass]="{ 'loading_button-loading': loading || icoSrc }"
  [type]="type"
  [disabled]="loading || disabled"
  (click)="handleClick.emit()"
>
  <div class="loading_button--wrapper">
    @if (icoSrc && !loading) {
      <span [inlineSVG]="icoSrc"></span>
    } @else {
      <span
        class="spinner-border spinner-border-md"
        role="status"
        aria-hidden="true"
      ></span>
    }

    <ng-template #spinner>
      <span
        class="spinner-border spinner-border-md"
        role="status"
        aria-hidden="true"
      ></span>
    </ng-template>

    <div
      class="loading_button--content"
      [ngClass]="{ 'loading_button-postfix': !isPrefixIco }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</button>
